import { Component, OnInit } from '@angular/core';
import { Course } from 'src/app/models/course';
import { Stream } from 'src/app/models/stream';
import { SupporterService } from 'src/app/services/supporter.service';
import { CourseService } from 'src/app/services/course.service';
import { StreamService } from 'src/app/services/stream.service';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { FilterService } from 'src/app/services/filter.service';
import { RoleFilters } from 'src/app/models/roleFilters';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-supporter',
  templateUrl: './supporter.component.html',
  styleUrls: ['./supporter.component.scss']
})
export class SupporterComponent implements OnInit {
  public supporterId;
  public loadingSupporter:boolean=true;
  public loadingCourses:boolean=true;
  public loadingSeries:boolean=true;
  public supporter;
  public courses:Course[];
  public series:Stream[];
  public supporterImagePath:string;
  public blurb:string;
  public roleFilters: RoleFilters;
  public loggedIn:boolean=false;
  public breadcrumbLinks=[{routerLink:'/supporters', label: 'In association with'}];
  public thisPage:string = '';

  constructor(
    private _supporter: SupporterService,
    private _course: CourseService,
    private _stream: StreamService,
    private _route: ActivatedRoute,
    private _auth: AuthenticationService,
    private _filter: FilterService
  ) {
    this._auth.loggedIn.subscribe(res=>{
      this.loggedIn=res;
    });
    this.supporterId=this._route.snapshot.paramMap.get('id');
    this._filter.roleFiltersSubject.subscribe(
      (data:RoleFilters) => {
        this.roleFilters=data;
        this._course.getSupporterCourses(this.supporterId, this.roleFilters, this.loggedIn).subscribe(
          res=>{
            this.courses=res;
          }
        );
      }
    );
  }

  ngOnInit() {
    forkJoin(
      this._supporter.getSupporter(this.supporterId),
      this._course.getSupporterCourses(this.supporterId, this.roleFilters, this.loggedIn),
      this._stream.getSupporterStreams(this.supporterId, this.loggedIn)
    ).subscribe(
      data=>{
        this.supporter=data[0];
        this.loadingSupporter=false;
        this.courses=data[1];
        this.loadingCourses=false;
        this.series=data[2];
        this.loadingSeries=false;
        this.thisPage=this.supporter.name;
      }
    );
  }

}
